import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { cleanEmpty } from 'utils/genericFunctions';
import { Types, ConsultarSiglasRequest } from './types';

// ACTIONS
import { consultarSiglasSuccess, consultarSiglasFailure } from './actions';

function* consultarSiglas(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: ConsultarSiglasRequest } = request;

	let body = { ...payload };

	delete body.current;

	body = cleanEmpty(body) as ConsultarSiglasRequest;

	const response: ApiResponse = yield call(getApi, token || '', PATH_SGU_API, `siglas`, body);

	if (response.status === 200) {
		yield put(consultarSiglasSuccess(response));
	} else {
		yield put(consultarSiglasFailure());
	}
}

export default all([
	takeLatest(Types.CONSULTAR_SIGLAS_REQUEST, consultarSiglas),
]);
